import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesCourseBuilderLockBoldIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M18.75 10.065V6.75C18.75 3.022 15.728 0 12 0S5.25 3.022 5.25 6.75v3.315c-1.68.843-2.743 2.558-2.75 4.437v4.5c.003 2.76 2.24 4.997 5 5h9c2.76-.003 4.997-2.24 5-5v-4.5c-.007-1.879-1.07-3.594-2.75-4.437zM14 16.454c0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2 2 .895 2 2zM12 2.502c2.346.003 4.247 1.903 4.25 4.249v2.251c0 .276-.224.5-.5.5h-7.5c-.276 0-.5-.224-.5-.5V6.75C7.754 4.405 9.655 2.505 12 2.502z" transform="translate(0 -.002)"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesCourseBuilderLockBoldIcon = __decorateClass([
  customElement("elm-products-and-pages-course-builder-lock-bold-icon")
], ProductsAndPagesCourseBuilderLockBoldIcon);
export { ProductsAndPagesCourseBuilderLockBoldIcon };
